import { IconName } from '@src/components/base/Icon'
import { EhrCoachSpecialty } from '@src/types'

export interface Specialty {
  id: number
  key: string
  name: string
  order: number
}

export const specialtyToIconMap: Record<EhrCoachSpecialty, IconName> = {
  [EhrCoachSpecialty.WeightConcerns]: 'scales',
  [EhrCoachSpecialty.EatingDisorders]: 'fork-knife',
  [EhrCoachSpecialty.GutHealth]: 'microscope',
  [EhrCoachSpecialty.PrediabetesDiabetes]: 'chart-line',
  [EhrCoachSpecialty.AutoimmuneConditions]: 'first-aid',
  [EhrCoachSpecialty.ChronicFatigue]: 'moon-stars',
  [EhrCoachSpecialty.FoodAllergies]: 'fork-knife',
  [EhrCoachSpecialty.HeartDisease]: 'heart',
  [EhrCoachSpecialty.Cancer]: 'first-aid',
  [EhrCoachSpecialty.ThyroidDisorders]: 'thermometer',
  [EhrCoachSpecialty.MindfulEating]: 'yin-yang',
  [EhrCoachSpecialty.PrenatalNutrition]: 'baby',
  [EhrCoachSpecialty.Fertility]: 'heart',
  [EhrCoachSpecialty.WomensHealth]: 'gender-female',
  [EhrCoachSpecialty.MensHealth]: 'gender-male',
  [EhrCoachSpecialty.SportsPerformance]: 'barbell',
  [EhrCoachSpecialty.HealthyAging]: 'calendar',
  [EhrCoachSpecialty.HealthOptimization]: 'calendar',
  [EhrCoachSpecialty.HormonalHealth]: 'first-aid',
  [EhrCoachSpecialty.IntegrativeFunctionalNutrition]: 'fork-knife',
  [EhrCoachSpecialty.MetabolicHealth]: 'chart-line',
  [EhrCoachSpecialty.Bariatric]: 'stethoscope',
  [EhrCoachSpecialty.StressManagement]: 'flower-lotus',
  [EhrCoachSpecialty.Osteoporosis]: 'bone',
  [EhrCoachSpecialty.KidneyStones]: 'stethoscope',
}
